import React, { useState } from 'react'
import { Typography, Box, TextField, MenuItem } from '@mui/material'
import styled from 'styled-components'
import { AlertTriangle, XCircle } from 'lucide-react'
import { CommentsCancelamento } from './CommentsCancelamento'

const FilterContainer = styled(Box)`
  background: #fff;
  border-radius: 7px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  margin-bottom: 24px;
  width: 100%;
`

// Adicionando animação CSS global
const style = document.createElement('style');
style.textContent = `
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.05);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;
document.head.appendChild(style);

export function CancelamentoAssinatura() {
  const [period, setPeriod] = useState('last-30-days')

  return (
    <Box sx={{ 
      padding: 0, 
      minHeight: 'calc(100vh - 100px)',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '-30px',
      paddingTop: '30px'
    }}>
      <Box sx={{ padding: 3 }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'left', 
          gap: 2, 
          marginBottom: 3,
          justifyContent: 'left'
        }}>
          <XCircle 
            size={40} 
            color="#F97B18" 
            style={{ 
              filter: 'drop-shadow(0 2px 4px rgba(249, 123, 24, 0.3))',
              animation: 'pulse 2s infinite'
            }} 
          />
          <Typography 
            variant="h4" 
            gutterBottom 
            sx={{ 
              color: '#F97B18',
              fontWeight: 'bold',
              textShadow: '0 2px 4px rgba(249, 123, 24, 0.2)',
              margin: 0
            }}
          >
            Cancelamento de Assinaturas
          </Typography>
        </Box>

        {/* Filtro de Período */}
        <FilterContainer>
        <TextField
          select
          label="PERÍODO"
          variant="outlined"
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="all-period">TODO PERÍODO</MenuItem>
          <MenuItem value="last-90-days">ÚLTIMOS 90 DIAS</MenuItem>
          <MenuItem value="last-30-days">ÚLTIMOS 30 DIAS</MenuItem>
          <MenuItem value="last-7-days">ÚLTIMOS 7 DIAS</MenuItem>
        </TextField>
        </FilterContainer>
      </Box>

      {/* Seção de Comentários */}
      <Box sx={{ flex: 1, width: '100%', padding: 3, paddingTop: 0 }}>
        <CommentsCancelamento period={period} />
      </Box>
    </Box>
  )
}
